import React, { Component } from 'react';
import { push } from 'react-router-redux';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { RaisedButton } from 'material-ui';
import { JiraFlatButton } from '../../../tc-ui/small-buttons';

const { string, func, object } = PropTypes;

class ContractTaskList extends Component {

  goToContractList = (additionalQuery, label) => () => {
    this.track(label);
    const query = {
      searchCategory: 'all contracts',
      searchingAllYears: false,
      ...additionalQuery,
    };

    this.props.push({
      pathname: `/contracting/contract-list/search`,
      query,
    });
  }

  track = (label) => {
    window.dataLayer.push({
      event: 'TRACK_EVENT',
      ev: {
        category: 'Click Contract Task List',
        action: label,
      },
    });
  };

  goToTemplateList = (additionalQuery, label) => () => {
    this.track(label);
    const query = {
      searchingAllYears: false,
      ...additionalQuery,
    };

    this.props.push({
      pathname: `/contracting/template-list`,
      query,
    });
  }

  render() {
    const {
      data: {
        tcFormatNewPending,
        tcFormatUpdatesPending,
        externalWFilesPending,
        externalTotalPending,
        tcFormatLoading,
        tcFormatTotalToBeLoaded,
        externalFormatLoading,
        externalFormatTotalToBeLoaded,
        requests,
        unfinishedDrafts,
        notSentTemplates,
      },
      companyType,
    } = this.props;
    const processedData = (() => {
      if (companyType === 'Supplier') {
        return [{
          giantLabel: 'Rate Requests',
          width: '35%',
          color: '#31b5f7bd',
          onClick: () => {
            this.track('Rate Requests');
            this.props.push('/contracting/contract-list/recent');
          },
          secondary: [{
            label: 'Outstanding Rate Requests',
            value: requests,
            width: '100%',
            onClick: () => {
              this.track('Outstanding Rate Requests');
              this.props.push('/contracting/contract-list/recent');
            },
          }]
        },{
          giantLabel: 'Templates to be Actioned',
          width: '65%',
          onClick: this.goToTemplateList({
            statusesFilter: ['not sent', 'draft', 'new draft'],
          }, 'Templates to be Actioned'),
          color: '#43a669ad',
          secondary: [{
            label: 'Unfinished Drafts',
            value: unfinishedDrafts,
            width: '48%',
            onClick: this.goToTemplateList({
              statusesFilter: ['draft', 'new draft'],
            }, 'Templates to be Actioned'),
          }, {
            label: 'Templates Not Sent',
            value: notSentTemplates,
            width: '48%',
            onClick: this.goToTemplateList({
              statusesFilter: ['not sent'],
            }, 'Templates to be Actioned'),
          }],
        }];
      }
      return [{
        giantLabel: 'Waiting to be Accepted',
        width: '50%',
        onClick: this.goToContractList({
          stateFilterForBuyer: ['received'],
        }, 'Waiting to be Accepted'),
        color: '#31b5f7bd',
        secondary: [{
          label: 'TourConnect Format',
          value: tcFormatNewPending + tcFormatUpdatesPending,
          onClick: this.goToContractList({
            stateFilterForBuyer: ['received'],
            contractTypeFilter: ['tc-new', 'tc-updates'],
          }, 'TourConnect Format'),
          width: '48%',
          third: [
            {
              label: `${tcFormatNewPending} New`,
              onClick: this.goToContractList({
                stateFilterForBuyer: ['received'],
                contractTypeFilter: ['tc-new'],
              }, `${tcFormatNewPending} New`),
            },
            {
              label: `${tcFormatUpdatesPending} Updates`,
              onClick: this.goToContractList({
                stateFilterForBuyer: ['received'],
                contractTypeFilter: ['tc-updates'],
              }, `${tcFormatUpdatesPending} Updates`),
            },
          ],
        }, {
          label: 'External Format',
          value: externalTotalPending,
          onClick: this.goToContractList({
            stateFilterForBuyer: ['received'],
            contractTypeFilter: ['external-files', 'external-nofiles'],
          }, 'External Format'),
          width: '48%',
          third: [
            {
              label: `${externalWFilesPending} with Files`,
              onClick: this.goToContractList({
                stateFilterForBuyer: ['received'],
                contractTypeFilter: ['external-files'],
              }, `${externalWFilesPending} with Files`),
            },
          ],
        }],
      }, {
        giantLabel: 'Waiting to be Loaded',
        width: '50%',
        onClick: this.goToContractList({
          stateFilterForBuyer: ['loading', 'accepted'],
        }, 'Waiting to be Loaded'),
        color: '#43a669ad',
        secondary: [{
          label: 'TourConnect Format',
          value: tcFormatTotalToBeLoaded,
          onClick: this.goToContractList({
            stateFilterForBuyer: ['loading', 'accepted'],
            contractTypeFilter: ['tc-new', 'tc-updates'],
          }, 'TourConnect Format'),
          width: '48%',
          third: [
            {
              label: `${tcFormatLoading} Loading`,
              onClick: this.goToContractList({
                stateFilterForBuyer: ['loading'],
                contractTypeFilter: ['tc-new', 'tc-updates'],
              }, `${tcFormatLoading} Loading`),
            },
          ],
        }, {
          label: 'External Format',
          value: externalFormatTotalToBeLoaded,
          onClick: this.goToContractList({
            stateFilterForBuyer: ['loading', 'accepted'],
            contractTypeFilter: ['external-files', 'external-nofiles'],
          }, 'External Format'),
          width: '48%',
          third: [
            {
              label: `${externalFormatLoading} Loading`,
              onClick: this.goToContractList({
                stateFilterForBuyer: ['loading'],
                contractTypeFilter: ['external-files', 'external-nofiles'],
              }, `${externalFormatLoading} Loading`),
            },
          ],
        }],
      }];
    })();
    const flexStyle = { display: 'flex', alignItem: 'flex-start', justifyContent: 'space-between' };
    return (<div style={flexStyle}>
      {
        processedData.map(({ giantLabel, color, secondary, query, onClick, width }, i) => (
          <div key={i} style={{ borderRight: !i ? '1px solid #efefef' : '', width, textAlign: 'center', padding: '0 16px' }}>
            {/*<div style={{ color: 'white', backgroundColor: color, lineHeight: '48px', fontSize: '20px' }}>{giantLabel}</div>*/}
            <RaisedButton
              label={giantLabel}
              labelStyle={{ textTransform: 'none', fontSize: '20px', color: 'white', lineHeight: '48px' }}
              onClick={onClick}
              style={{ height: '48px' }}
              backgroundColor={color}
            />
            <div style={flexStyle}>
              {
                secondary.map(({
                                 label,
                                 value,
                                 third,
                                 onClick: secondClick,
                                 width: secondWidth,
                               }, si) => (
                  <div key={si} style={{ width: secondWidth }}>
                    <div>
                      <a
                        style={{ display: 'block', fontSize: '1.5vw', lineHeight: '54px', textDecoration: 'underline', cursor: 'pointer' }}
                        onClick={secondClick}
                      >
                        {value}
                      </a>
                      <span style={{ display: 'block', fontSize: '14px' }}>
                        {label}
                      </span>
                    </div>
                    <div style={{ width: '100%', margin: '8px auto', justifyContent: 'center', flexWrap: 'wrap' }} className="flex-tc-sb">
                      {
                        Boolean(third) && third.map(({ label: smallLabel, onClick: thirdClick }, ti) => (
                          <JiraFlatButton
                            key={ti}
                            label={smallLabel}
                            style={{ marginLeft: ti ? '4px' : 0 }}
                            labelStyle={{ padding: '2px 4px' }}
                            onTouchTap={thirdClick}
                          />
                        ))
                      }
                    </div>
                  </div>
                ))
              }
            </div>
          </div>
        ))
      }
    </div>);
  }
}
ContractTaskList.propTypes = {
  data: object,
  dispatch: func,
  style: object,
  companyId: string,
};

export default connect(({ user }) => ({
  companyId: user.getIn(['company', 'companyId']),
  companyType: user.getIn(['company', 'companyType']),
}), ({
  push,
}))(ContractTaskList);



// WEBPACK FOOTER //
// ./src/app/components/contracting-dashboard/components/charts/ContractTaskList.jsx